(ns assemble.assets-page.drawer.db
  (:require [re-frame.core :as rf]))

(rf/reg-event-fx :assemble.assets-page/drawer-close
  (fn [_]
    {:router/update-query #(dissoc % :file)}))

(rf/reg-event-fx :assemble.assets-page/fonts-drawer-close
  (fn [_]
    {:router/update-query #(dissoc % :font-family)}))

(rf/reg-event-fx :assemble.assets-page/folders-drawer-close
  (fn [_]
    {:router/update-query #(dissoc % :folder)}))

(rf/reg-event-fx :assemble.assets-page/set-current-folder
  (fn [_ [_ data]]
    {:router/update-query #(-> (assoc % :folder (:asset-tree/id data))
                               (dissoc :font-family)
                               (dissoc :file))}))

(rf/reg-event-fx :assemble.assets-page/set-current-file
  (fn [_ [_ data]]
    {:router/update-query #(-> (assoc % :file (:asset/id data))
                               (dissoc :font-family)
                               (dissoc :folder))}))

(rf/reg-event-fx :assemble.assets-page/set-current-font-family
  (fn [_ [_ font-family-name]]
    {:router/update-query #(-> (assoc % :font-family font-family-name)
                               (dissoc :file)
                               (dissoc :folder))}))
